import { EditButton, TopToolbar } from 'react-admin';

export default function CustomEditAction(props) {
  return (
    <TopToolbar>
      <EditButton {...props} />
    </TopToolbar>
  );
}
